module.exports = __webpack_public_path__ + "img/6f90167.png";